
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saa/new",
      function () {
        return require("private-next-pages/saa/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saa/new"])
      });
    }
  